import { combineReducers } from '@reduxjs/toolkit';

import adminActiveGunReducer from './slices/AdminActiveGunSlice';
import adminAdvertisementLocationReducer from './slices/AdminAdvertisementsLocationSlice';
import adminAdvertisementReducer from './slices/AdminAdvertisementsSlice';
import adminAffiliateAnalyticsReducer from './slices/AdminAffiliateAnalyticsSlice';
import adminAffiliateCodeReducer from './slices/AdminAffiliateCodeSlice';
import adminBannerReducer from './slices/AdminBannerSlice';
import adminBlogCategoriesReducer from './slices/AdminBlogCategoriesSlice';
import adminBlogReducer from './slices/AdminBlogSlice';
import adminCategoriesReducer from './slices/AdminCategoriesSlice';
import adminContentPagesReducer from './slices/AdminContentPagesSlice';
import adminCouponReducer from './slices/AdminCouponSlice';
import adminCustomerGroupReducer from './slices/AdminCustomerGroupSlice';
import adminCustomerReducer from './slices/AdminCustomerSlice';
import adminDynamicModuleReducer from './slices/AdminDynamicModuleSlice';
import adminEmailTemplateReducer from './slices/AdminEmailTemplateSlice';
import adminEmployeeReducer from './slices/AdminEmployeeSlice';
import adminFaqReducer from './slices/AdminFaqSlice';
import adminFFLReducer from './slices/AdminFFLSlice';
import adminGeneralSettingReducer from './slices/AdminGeneralSettingSlice';
import adminGlobalReducer from './slices/AdminGlobalSlice';
import adminIntegrationRequestReducer from './slices/AdminIntegrationRequestSlice';
import adminManufacturerReducer from './slices/AdminManufacturerSlice';
import adminMessageReducer from './slices/AdminMessageSlice';
import adminModuleCountReducer from './slices/AdminModuleCountSlice';
import adminOrderReportReducer from './slices/AdminOrderReportSlice';
import adminOrderReducer from './slices/AdminOrderSlice';
import adminProductAttributeReducer from './slices/AdminProductAttributeSlice';
import adminProductDraftReducer from './slices/AdminProductDraftSlice';
import adminProductReviewReducer from './slices/AdminProductReviewSlice';
import adminProductReducer from './slices/AdminProductSlice';
import adminPurchaseFormsReducer from './slices/AdminPurchaseFormsSlice';
import adminReturnRequestReducer from './slices/AdminReturnRequestSlice';
import adminReviewReducer from './slices/AdminReviewSlice';
import adminRoleReducer from './slices/AdminRoleSlice';
import adminSearchTermsReducer from './slices/AdminSearchTermsSlice';
import adminSmsLogReducer from './slices/AdminSmsLogSlice';
import adminSMSTemplateReducer from './slices/AdminSMSTemplateSlice';
import adminSoldGunReducer from './slices/AdminSoldGunSlice';
import adminSubscriptionPlanReducer from './slices/AdminSubscriptionPlanSlice';
import adminTransactionReducer from './slices/AdminTransactionSlice';
import adminTransferRequestReducer from './slices/AdminTransferRequestSlice';
import adminURLRewriteSlice from './slices/AdminURLRewriteSlice';
import adminUserReducer from './slices/AdminUserSlice';

const AdminReducer = combineReducers({
  adminUser: adminUserReducer,
  adminDynamicModule: adminDynamicModuleReducer,
  adminSubscriptionPlan: adminSubscriptionPlanReducer,
  adminFFL: adminFFLReducer,
  adminOrder: adminOrderReducer,
  adminCustomer: adminCustomerReducer,
  adminCustomerGroup: adminCustomerGroupReducer,
  adminRole: adminRoleReducer,
  adminEmployee: adminEmployeeReducer,
  adminEmailTemplate: adminEmailTemplateReducer,
  adminSMSTemplate: adminSMSTemplateReducer,
  adminModuleCount: adminModuleCountReducer,
  adminCategories: adminCategoriesReducer,
  adminManufacturer: adminManufacturerReducer,
  adminBanner: adminBannerReducer,
  adminProduct: adminProductReducer,
  adminProductDraft: adminProductDraftReducer,
  adminBlog: adminBlogReducer,
  adminBlogCategories: adminBlogCategoriesReducer,
  adminAdvertisement: adminAdvertisementReducer,
  adminURLRewrite: adminURLRewriteSlice,
  adminProductAttribute: adminProductAttributeReducer,
  adminContentPages: adminContentPagesReducer,
  adminAdvertisementLocation: adminAdvertisementLocationReducer,
  adminActiveGun: adminActiveGunReducer,
  adminSoldGun: adminSoldGunReducer,
  adminPurchaseForms: adminPurchaseFormsReducer,
  adminReview: adminReviewReducer,
  adminAffiliateCode: adminAffiliateCodeReducer,
  adminAffiliateAnalytics: adminAffiliateAnalyticsReducer,
  adminCoupon: adminCouponReducer,
  adminMessage: adminMessageReducer,
  adminProductReview: adminProductReviewReducer,
  adminGeneralSetting: adminGeneralSettingReducer,
  adminGlobal: adminGlobalReducer,
  adminTransferRequest: adminTransferRequestReducer,
  adminReturnRequest: adminReturnRequestReducer,
  adminTransaction: adminTransactionReducer,
  adminOrderReport: adminOrderReportReducer,
  adminFaq: adminFaqReducer,
  adminSearchTerms: adminSearchTermsReducer,
  adminSmsLog: adminSmsLogReducer,
  adminIntegrationRequestData: adminIntegrationRequestReducer,
});
// ADMIN STATE TYPE
export type AdminState = ReturnType<typeof AdminReducer>;
export default AdminReducer;
